export default __webpack_public_path__ + "78ee787020c3e590704bb04cab22e74b.jpg";